document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("upsell-modal");
  if (!modal) return;

  document.querySelectorAll("form[action='/cart/add']").forEach(form => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      }).then(() => {
        modal.style.display = "block";
      });
    });
  });

  document.querySelectorAll(".add-upsell").forEach(btn => {
    btn.addEventListener("click", function () {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.dataset.id,
          quantity: 1
        })
      });
      this.innerText = "Agregado ✓";
    });
  });

  document.getElementById("go-checkout").onclick = () => {
    window.location.href = "/checkout";
  };

});
